export default __webpack_public_path__ + "static/media/loader_3d_egem.f5cc6048.gif";